<template>
  <div>
    <b-modal
      id="seeProductsModal"
      cancel-variant="outline-secondary"
      centered
      :title="$t('contracts')"
      size="sm"
      hide-footer
    >
  
      <b-table
        small
        :fields="fields"
        :items="seeProducts"
        responsive
        :tbody-tr-class="['tableRowClass']"
        class="mt-2"
        sticky-header="400px"
        :no-border-collapse="true"
        show-empty
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>
        
        <template #cell(numeration)="data">
          <span>
            {{ data.index + 1 }}
          </span>
        </template>
   
        <template #cell(contract_number)="data">
          <span>
            {{ data.item.contract_number }}
          </span>
        </template>

        <template #cell(amount)="data">
          <span>
            {{ $_formatPriceMixin(data.item.amount) }} сум
          </span>
        </template>

        <template #cell(actions)="props">
          <b-button
            variant="primary"
            size="sm"
            class="mt-50 mb-50"
            @click="$router.push(`/view-agreements/${props.item.id}/`)"
          >
            <feather-icon icon="ChevronsRightIcon" size="18" />
          </b-button>
        </template>


      </b-table>

    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BModal, VBModal, BTable,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import priceFormatMixin from "@/mixins/priceFormatMixin";

export default {
  components: {
    BButton,
    BModal,
    BTable,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [priceFormatMixin],
  props: {
    seeProducts: {
      type: [Array],
    },
  },
  data() {
    return {
      fields: [
        {
          label: '№',
          key: 'numeration',
        },
        {
          label: 'сontract_number',
          key: 'contract_number',
        },
        {
          label: 'amount',
          key: 'amount',
        },
        {
          label: 'actions',
          key: 'actions',
        },
      ],
    }
  },
  async mounted() {
    
  },
  computed: {

  },
  methods: {
    
  },
}
</script>

<style lang="scss">

</style>
